import * as React from "react";

/*
 * A heading.
 */
export class Heading extends React.Component<{ children?: React.ReactNode }, {}> {
  render(): JSX.Element {
    return (
      <div
        style={{
          fontSize: "48px",
          fontWeight: 600,
          color: "#333",
          margin: 0,
        }}
      >
        {this.props.children}
      </div>
    );
  }
}
